module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_page_edit-e050601c219f10fb47f4c9e0fb91b9bc.png";